import { selectPreferredLanguage } from 'tradera/state/language/selectors';
import {
    selectFeedbackItemsIds,
    selectHasTranslatedReview,
    selectIsLoadingFeedbackModel,
    selectTranslatedReviews,
    selectProfileFeedbackModel,
    showLoading
} from 'tradera/state/views/profile/selectors';
import {
    beginLoadingModel,
    beginLoadingTranslatedReviews,
    failedLoadingTranslatedReviews,
    setModel,
    setTranslatedReviews,
    showTranslatedReviews,
    setTranslationOnDemandIsDisabled,
    setFeedbackComment
} from 'tradera/state/views/profile/reducer';
import {
    fetchProfileModel,
    fetchReviews,
    postFeedbackReply
} from 'tradera/state/views/profile/api';
import {
    areLanguageCodesIso2Equal,
    getLanguageFromCountryCode
} from 'tradera/localization/languagecode';
import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';

export const fetchProfileFeedbackModel =
    ({ memberId, role, rating, page }) =>
    async (dispatch, getState) => {
        const state = getState();

        if (selectIsLoadingFeedbackModel(state)) {
            return;
        }

        dispatch(beginLoadingModel());

        dispatch(
            setModel({
                model: (
                    await fetchProfileModel({
                        memberId,
                        role,
                        rating,
                        page
                    })
                ).data
            })
        );
    };

export const saveFeedbackComment = (payload) => async (dispatch) => {
    const { feedbackId, comment } = payload;
    try {
        await postFeedbackReply(feedbackId, comment);
        dispatch(setFeedbackComment(payload));
    } catch {
        return Promise.reject();
    }
};

export const loadAndShowTranslatedReviews =
    (feedbackItemIds) => async (dispatch, getState) => {
        const state = getState();

        const toLanguageCodeIso2 = selectPreferredLanguage(
            getState()
        ).languageCodeIso2;

        const feedbackItems = selectProfileFeedbackModel(
            getState()
        )?.feedbackItems;
        const filteredFeedbackItemIds = feedbackItemIds
            .filter((id) => !selectHasTranslatedReview(id)(state))
            .filter(
                (id) =>
                    !areLanguageCodesIso2Equal(
                        toLanguageCodeIso2,
                        getLanguageFromCountryCode(
                            feedbackItems.find(({ gradeId }) => gradeId === id)
                                ?.feedbackMemberCountryCodeIso2,
                            selectIsFeatureEnabled('french-dutch-selectable')(
                                state
                            )
                        )
                    )
            );

        if (filteredFeedbackItemIds.length === 0) {
            return;
        }

        const translatedReviews = selectTranslatedReviews(getState());
        if (translatedReviews && translatedReviews.length > 0) {
            dispatch(
                showTranslatedReviews({
                    show: true
                })
            );
        }

        if (showLoading(getState()) === true) {
            // translation already loading
            return;
        }

        dispatch(beginLoadingTranslatedReviews());
        try {
            const result = await fetchReviews(
                filteredFeedbackItemIds,
                toLanguageCodeIso2
            );
            if (result.data.isTranslationOnDemandDisabled) {
                dispatch(setTranslationOnDemandIsDisabled());
                return;
            }

            dispatch(setTranslatedReviews(result.data));
            dispatch(
                showTranslatedReviews({
                    show: true,
                    language: toLanguageCodeIso2
                })
            );
        } catch (e) {
            dispatch(failedLoadingTranslatedReviews());
        }
    };

export const loadAndShowAllTranslatedReviews =
    () => async (dispatch, getState) => {
        const feedbackItemIds = selectFeedbackItemsIds(getState());
        await dispatch(loadAndShowTranslatedReviews(feedbackItemIds));
    };

export const hideTranslatedReviews = () =>
    showTranslatedReviews({ show: false });
